import settings from '../conf/settings';
import { encodeStateParam } from "./encoding";

export const isReturningFromOauth = () => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('code') || queryParams.get('error');
};

export const transformOauthQueryStringParameters = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const oauthCode = queryParams.get('code');
  const oauthError = queryParams.get('error');
  const normalizedOauthQueryString = (oauthCode ? `&oauthCode=${oauthCode}` : '') + (oauthError ? `&oauthError=${oauthError}` : '');
  return normalizedOauthQueryString;
};

export const replaceUrl = (url) => window.history.pushState(null, document.title, url || window.location.origin);

// const PAYPAL_OAUTH_URLS = {
//   PRD: "https://www.paypal.com/connect?flowEntry=static",
//   DEV: "https://www.sandbox.paypal.com/connect?flowEntry=static"
// };

export const getPaypalOauthUrl = (clientId, state) => {
  let url = `${settings.environment.PAYPAL_CONNECT_BASE_URL}&client_id=${clientId}&response_type=code&scope=profile email&redirect_uri=${window.location.origin}/`;
  if (state) url += `&state=${encodeStateParam(state)}`;
  return url;
};

// export const getPaypalOauthUrl = clientId => {
//   return `${settings.environment.DEPLOYMENT_ENVIRONMENT === 'DEV' ? PAYPAL_OAUTH_URLS.DEV : PAYPAL_OAUTH_URLS.PRD}?flowEntry=static&client_id=${clientId}&response_type=code&scope=profile&redirect_uri=${window.location.origin}/`;
// };
